import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
	ordersModal: ["orders"],
	modalCleanOrders: [],
	modalAddOrder: ["order"],
	modalRemoveOrder: ["order"],
	modalCleanSelectOrders: [],
	modalCleanAll:[]
});

//Reducer Handlers
const INITIAL_STATE = {
	ordersModal: null,
	selectOrdersModal: []
};

const ordersModal = (state = INITIAL_STATE, action) => {
	return { ...state, ordersModal: action.payload }
};

const cleanOrders = (state = INITIAL_STATE, action) => {
	return { ...state, ordersModal: null }
};

const add = (state = INITIAL_STATE, action) => {
	return { ...state, selectOrdersModal: [...state.selectOrdersModal, action.orderId] }
};

const remove = (state = INITIAL_STATE, action) => {
	return { ...state, selectOrdersModal: [...state.selectOrdersModal.filter(filteredOrder => filteredOrder !== action.orderId)] };
}

const cleanSelectOrders = (state = INITIAL_STATE, action) => {
	return { ...state, selectOrdersModal: [] }
};

const cleanAll = (state = INITIAL_STATE, action) =>
	INITIAL_STATE

//Criando Reducer
export default createReducer(INITIAL_STATE, {
	[Types.ORDERS_MODAL]: ordersModal,
	[Types.MODAL_ADD_ORDER]: add,
	[Types.MODAL_REMOVE_ORDER]: remove,
	[Types.MODAL_CLEAN_SELECT_ORDERS]: cleanSelectOrders,
	[Types.MODAL_CLEAN_ORDERS]: cleanOrders,
	[Types.MODAL_CLEAN_ALL]: cleanAll
});
